<template>
  <div class="section industry">
   <b-modal id="industry-settings" hide-footer title="Időszak kiválasztása">
      <b-form-group
        id="industry-interval"
        label="Időszak"
        label-for="industry-trend-interval-select"
        description="Válaszd ki a vizsgálandó időszakot."
      >
        <b-form-select id="industry-trend-interval-select" v-model="preferences.interval" :options="industryTrendIntervals"></b-form-select>
      </b-form-group>
    </b-modal>

    <h4 class="h4 section-title">
      <span>Ajánlások trendje az iparágadon belül</span>
      <b-button-group size="sm" class="float-right">
        <b-button variant="text" @click="$bvModal.show('industry-settings')">
          <i class="fas fa-tools"></i>
        </b-button>
      </b-button-group>
    </h4>
    <div class="section-content">
        <loading v-model="chartLoading" :height="600">
          <trend :chartData="chartData" :height="600"></trend>
        </loading>
    </div>
  </div>
</template>
<script>
  import Loading from '../../common/LoadingPlaceholder'
  import Trend from './Trend'

  export default {
    components: {
      'trend': Trend,
      'loading': Loading
    },
    data() {
      return {
        preferences: {
          interval: 3
        },
        industryTrendIntervals: [
          { value: 2, text: '2 hónap' },
          { value: 3, text: '3 hónap' },
          { value: 6, text: '6 hónap' },
          { value: 12, text: '12 hónap' },
        ],
        chartLoading: true,
        chartData: {}
      }
    },
    computed: {
    },
    watch: {
      'preferences.interval': function(interval) {
        this.updateIndustryChart(interval)
        this.$bvModal.hide('industry-settings')

        this.$root.setPreference('charts.industry.trend.interval', interval)
      }
    },
    mounted() {
      this.preferences.interval = this.$root.getPreference('charts.industry.trend.interval', 3)

      this.updateIndustryChart(this.preferences.interval)
    },
    methods: {
      updateIndustryChart(interval) {
        this.chartLoading = true
        this.$http.get(this.$url('api.statistics.industry-trend', interval))
          .then(({data}) => {
            this.chartData = data
            this.chartLoading = false
          })
      },
    }
  }
</script>